import { Component, OnInit, HostListener } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from "../../../common/services/confirmation-dialog.service";
import { ToastrService } from "ngx-toastr";
import { OpUsersService } from "../../../common/services/op-users.service";
import { environment } from "src/environments/environment";
import { SessionService } from "src/app/session.service";

@Component({
  selector: 'app-Orderview-Login',
  templateUrl: './op-orderviewLogin.component.html',
  styleUrls: ['./op-orderviewLogin.component.css']
})
export class OrderviewLoginComponent {
  loginForm: FormGroup;
  password: any;
  email: any;
  show = false;
  conshow = false;
  title: string;
  showVerifyMessage = false;
  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private activeRoute: ActivatedRoute,
    private route: Router,
    private toastr: ToastrService,
    private confirmationDialogService: ConfirmationDialogService,
    private userServ: OpUsersService,
    private http: HttpClient,
    private sessionServ: SessionService,
  ) { }

  loginFormBuilder() {
      this.loginForm = new FormGroup({
        email: new FormControl(null, Validators.required),
        password: new FormControl(null, Validators.required),
        confirmpassword: new FormControl(null, Validators.required)
      });
  }

  passwordView() {
    if (this.password === "password") {
      this.password = "text";
      this.show = true;
    } else {
      this.password = "password";
      this.show = false;
    }
  }
  conpasswordView() {
    if (this.password === "password") {
      this.password = "text";
      this.conshow = true;
    } else {
      this.password = "password";
      this.conshow = false;
    }
  }
  ngOnInit() {
    this.activeRoute.queryParams.subscribe((params) => {
      if (Object.keys(params).length > 0 && params.constructor === Object) {
        console.log(params);
        this.onVerifySubmit(params);
      }
    });
    this.loginFormBuilder();
    this.email = this.userServ.getCustomerUserInfo().email;

    this.loginForm.patchValue({
      email: this.email
    });

  }

  handleSuccess(event) { }
  handleReset(event) { }
  handleExpire(event) { }
  onVerifySubmit(formData) {

    if (formData.hasOwnProperty('email') && formData.hasOwnProperty('password')) {
      let toastInfo = this.toastr.info(
        "Processing Request...",
        "",
        {
          positionClass: "toast-center-center",
          disableTimeOut: true
        },
      );

      this.sessionServ.verifyEmail(formData.email, formData.password).subscribe(
        (res: any) => {
          // sessionStorage.clear();
          // location.reload();
          this.showVerifyMessage = true;
          this.toastr.success(
            "We have sent an email verification link to your email address please verify your account.",
            "Email Verified",
            {
              positionClass: "toast-center-center",
              timeOut: 30000,
            }
          );
          this.toastr.remove(toastInfo.toastId);
        },
        (err: any) => {
          this.toastr.remove(toastInfo.toastId);
          console.error(err);
          console.log('error', err);
          this.toastr.remove(Number(toastInfo.toastId));
          this.toastr.error(
            "email or Password is incorrect",
            "Authentication Failed!",
            {
              positionClass: "toast-center-center",
            }
          );
        }
      );
    }

  }

  confirmPassword() {
    if (
      this.loginForm.controls.password.value ==
      this.loginForm.controls.confirmpassword.value
    ) {
      this.toastr.info("Password matched", "Confirm Password", {
        positionClass: "toast-bottom-right",
      });
    } else {
      if (
        this.loginForm.controls.password.value.length ==
        this.loginForm.controls.confirmpassword.value.length
      ) {
        this.toastr.warning("Password not matched", "Confirm Password", {
          positionClass: "toast-bottom-right",
        });
      }
    }
  }

  passwordsMatch(group: FormGroup) {
    const newPassword = group.get('newPassword') ? group.get('newPassword').value : null;
    const confirmPassword = group.get('confirmPassword')? group.get('confirmPassword').value : null;
    return newPassword === confirmPassword ? null : { notMatching: true };
  }

  closeModal() {
    this.activeModal.close();
  }

  verify() {
    if (this.loginForm.valid) {
      console.log("Verification successful", this.loginForm.value);

    }
  }

  onResend(event: Event) {
    event.preventDefault();
    this.onVerifySubmit(this.loginForm.value);
  }
}
